module.exports = __webpack_public_path__ + "static/2-006abfa10d04f5e963d8cf48d9f189e3.jpg";